import { onScopeDispose, watch } from 'vue'
import { useRouter } from 'vue-router'
import { toast } from 'vue-sonner'
import { useAuthStore } from '@/stores/auth'
import { activityPath, orderIdOf, scopeOf, useRealtimeStore } from '@/stores/realtime'

/**
 * Keeps the user socket open while signed in and toasts activity the user is
 * not already looking at. Call once, from the app root.
 */
export function useRealtimeSession() {
  const authStore = useAuthStore()
  const realtime = useRealtimeStore()
  const router = useRouter()

  watch(
    () => authStore.isAuthenticated,
    (signedIn) => (signedIn ? realtime.start() : realtime.stop()),
    { immediate: true },
  )

  const stopListening = realtime.onNotification((notification, seen) => {
    if (seen) return
    const orderId = orderIdOf(notification)
    const scope = scopeOf(notification)
    toast(notification.title, {
      description: notification.body,
      action: orderId
        ? {
            label: scope === 'messages' ? 'Reply' : 'View',
            onClick: () => router.push(activityPath(orderId, scope)),
          }
        : undefined,
    })
  })

  onScopeDispose(stopListening)
}
